document.addEventListener('DOMContentLoaded', () => {
  const drawerToggle = document.querySelector('[data-mobile-nav-toggle]');
  const drawer = document.querySelector('[data-mobile-drawer]');

  if (drawerToggle && drawer) {
    drawerToggle.addEventListener('click', () => {
      const isOpen = drawer.classList.toggle('is-open');
      drawerToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  document.querySelectorAll('[data-tabs]').forEach((tabsRoot) => {
    const buttons = tabsRoot.querySelectorAll('[data-tab-button]');
    const panels = tabsRoot.querySelectorAll('[data-tab-panel]');

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const target = button.getAttribute('data-tab-button');

        buttons.forEach((btn) => {
          const active = btn === button;
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        panels.forEach((panel) => {
          panel.classList.toggle(
            'is-active',
            panel.getAttribute('data-tab-panel') === target
          );
        });
      });
    });
  });

  document.querySelectorAll('[data-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-carousel-track]');
    const slides = track ? Array.from(track.children) : [];
    const prev = carousel.querySelector('[data-carousel-prev]');
    const next = carousel.querySelector('[data-carousel-next]');

    if (!track || slides.length <= 1) {
      if (prev) prev.style.display = 'none';
      if (next) next.style.display = 'none';
      return;
    }

    let index = 0;
    let autoplayTimer = null;

    const autoplayDelay = Number(carousel.dataset.carouselDelay) || 6000;

    const update = () => {
      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === index;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    };

    const goToPrevious = () => {
      index = index === 0 ? slides.length - 1 : index - 1;
      update();
    };

    const goToNext = () => {
      index = index === slides.length - 1 ? 0 : index + 1;
      update();
    };

    const stopAutoplay = () => {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    };

    const startAutoplay = () => {
      stopAutoplay();
      autoplayTimer = window.setInterval(goToNext, autoplayDelay);
    };

    prev?.addEventListener('click', () => {
      goToPrevious();
      startAutoplay();
    });

    next?.addEventListener('click', () => {
      goToNext();
      startAutoplay();
    });

    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);

    carousel.addEventListener('focusin', stopAutoplay);
    carousel.addEventListener('focusout', startAutoplay);

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });

    slides.forEach((slide, slideIndex) => {
      slide.classList.toggle('is-active', slideIndex === 0);
      slide.setAttribute('aria-hidden', slideIndex === 0 ? 'false' : 'true');
    });

    update();
    startAutoplay();
  });
});
/* =========================================================
   Ashmira Botanica - Adaptive Hero Text Contrast
   Detects active carousel image brightness
   ========================================================= */

document.addEventListener('DOMContentLoaded', function () {
  const heroSection = document.querySelector('#shopify-section-template--29757912187217__hero');
  if (!heroSection) return;

  const hero = heroSection.querySelector('.hero-minimal');
  const media = heroSection.querySelector('.hero-minimal__media');
  const track = heroSection.querySelector('[data-carousel-track]');
  const slides = Array.from(heroSection.querySelectorAll('.media-carousel__slide'));

  if (!hero || !media || !slides.length) return;

  function getMostVisibleSlide() {
    const mediaRect = media.getBoundingClientRect();

    let bestSlide = slides[0];
    let bestVisibleArea = 0;

    slides.forEach(function (slide) {
      const rect = slide.getBoundingClientRect();

      const overlapLeft = Math.max(mediaRect.left, rect.left);
      const overlapRight = Math.min(mediaRect.right, rect.right);
      const overlapTop = Math.max(mediaRect.top, rect.top);
      const overlapBottom = Math.min(mediaRect.bottom, rect.bottom);

      const overlapWidth = Math.max(0, overlapRight - overlapLeft);
      const overlapHeight = Math.max(0, overlapBottom - overlapTop);
      const visibleArea = overlapWidth * overlapHeight;

      if (visibleArea > bestVisibleArea) {
        bestVisibleArea = visibleArea;
        bestSlide = slide;
      }
    });

    return bestSlide;
  }

  function detectImageBrightness(img, callback) {
    if (!img) {
      callback('dark');
      return;
    }

    const runAnalysis = function () {
      try {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d', { willReadFrequently: true });

        const sampleWidth = 50;
        const sampleHeight = 50;

        canvas.width = sampleWidth;
        canvas.height = sampleHeight;

        ctx.drawImage(img, 0, 0, sampleWidth, sampleHeight);

        const imageData = ctx.getImageData(0, 0, sampleWidth, sampleHeight);
        const data = imageData.data;

        let totalBrightness = 0;
        let sampleCount = 0;

        for (let i = 0; i < data.length; i += 20) {
          const r = data[i];
          const g = data[i + 1];
          const b = data[i + 2];

          const brightness = (r * 299 + g * 587 + b * 114) / 1000;

          totalBrightness += brightness;
          sampleCount++;
        }

        const averageBrightness = totalBrightness / sampleCount;

        callback(averageBrightness >= 140 ? 'light' : 'dark');
      } catch (error) {
        callback('dark');
      }
    };

    if (img.complete && img.naturalWidth > 0) {
      runAnalysis();
    } else {
      img.addEventListener('load', runAnalysis, { once: true });
    }
  }

  function updateHeroContrast() {
    const activeSlide = getMostVisibleSlide();
    const img = activeSlide ? activeSlide.querySelector('img') : null;

    detectImageBrightness(img, function (theme) {
      hero.classList.remove('hero-minimal--image-light', 'hero-minimal--image-dark');
      hero.classList.add(theme === 'light' ? 'hero-minimal--image-light' : 'hero-minimal--image-dark');
    });
  }

  updateHeroContrast();

  const nextButton = heroSection.querySelector('[data-carousel-next]');
  const prevButton = heroSection.querySelector('[data-carousel-prev]');

  if (nextButton) {
    nextButton.addEventListener('click', function () {
      setTimeout(updateHeroContrast, 180);
      setTimeout(updateHeroContrast, 420);
    });
  }

  if (prevButton) {
    prevButton.addEventListener('click', function () {
      setTimeout(updateHeroContrast, 180);
      setTimeout(updateHeroContrast, 420);
    });
  }

  if (track) {
    const observer = new MutationObserver(function () {
      window.requestAnimationFrame(updateHeroContrast);
    });

    observer.observe(track, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['class', 'style']
    });
  }

  window.addEventListener('resize', function () {
    setTimeout(updateHeroContrast, 150);
  });

  setInterval(updateHeroContrast, 1500);
});